import { REMOVER_FILTRO_ITINERARIO_EMBARQUE } from '../types'

export default function removerFiltroItinerarioEmbarque (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_ITINERARIO_EMBARQUE
  }
}
